( function () {
	'use strict';

	// auto select when field is clicked
	function autoSelect () {
		function link ( scope, element ) {
			setTimeout( function () {
				element[ 0 ].select();
			}, 3 );
		}

		return {
			'restrict' : 'A',
			'link'     : link
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'autoSelect', autoSelect );
} )( );
